<template>
<div>
 
  <div class="page-header d-flex w-100 pt-3">
    <div class="title-col d-flex">
      <span class="title-icon">
        <b-icon-folder-fill></b-icon-folder-fill>
      </span>
      <span class="title-text">Reports</span>
   
    </div>
        <div class="input-group input-group-sm ml-auto"  style="width: 240px;">
            <input
              type="text"
              v-model="searchText"
              class="form-control"
              placeholder="Search"
            />
            <div class="input-group-append">
              <button class="btn btn-secondary" type="button" >
                <b-icon icon="search"></b-icon>
              </button>
            </div>
          </div>
  </div>
 <hr style="margin: 0 15px 0 15px">
  <div class="page-body sm-grid loading ">
         <ul
        class="sidebar-menu overflow-auto list fundres-list"
        v-bind:style="{ height: leftnaveHeight + 'px' }"
      >
       
        <list-view
          v-for="(link,index) in List"
          :key="index"
          v-bind:item="link"
          @clickEvent="getReportJSon"
        ></list-view>
      </ul>
        <!-- <ul class="list fundres-list" >
        <li v-for="(link,index) in List"
          :key="index"><a><i class="nt-arrow-right-fill"></i>{{link}}</a></li>
       
      </ul> -->

  </div>
</div>

</template>

<script>
import { createNamespacedHelpers } from "vuex";
import ListView from "./ListView"
const { mapState,mapActions } = createNamespacedHelpers("dynamicReport");
export default {
  
    components: {
   ListView
  },
  data: function() {
    return {
leftnaveHeight: 400,
searchText:""
    };
  },
    computed: {
    ...mapState(["linkList"]),
     List(){
       return this.linkList.filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1);
}
      // .filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1);
      
      
        //  let val = this.linkList
        // // Return a modified copy of engagements..
        // .map((i) => {
        //     // ..with all answered questions filtered out..
        //     i.reports = i.reports.filter((x) => x.name.toLowerCase() ===this.searchText.toLowerCase());
        //     return i;
        // })
        // // ..and only return engagements that have (unanswered) questions left
        // .filter((i) => i.reports.length !== 0);
        // console.log(val)
        // return val
        // Return a modified copy of engagements..
        // .map((i) => {
        //     // ..with all answered questions filtered out..
        //     i.reports = i.reports.filter((x) => x.name.toLowerCase() ===this.searchText.toLowerCase());
        //     return i;
        // })
        // // ..and only return engagements that have (unanswered) questions left
        // .filter((i) => i.reports.length !== 0);
      // let val = this.linkList.map(i=>{
      //   return i.reports.find(item=>{
      //      console.log(val,this.searchText)
      //     return item.name.toLowerCase()==this.searchText.toLowerCase()
          
      //   })
      // }).filter(i=>i);
      // console.log(val,this.searchText)
      // return val
    
  },
  methods:{
    ...mapActions(["loadReports","getReportJSon","search"]),

    getInfo(e){
       console.log('e',e)
    },
    getDataOnload(){
      this.loadReports();
    },
    // search(){
    //      this.List = this.List
    //     // Return a modified copy of engagements..
    //     .map((i) => {
    //         // ..with all answered questions filtered out..
    //         i.reports = i.reports.filter((x) => x.name.toLowerCase() ===this.searchText.toLowerCase());
    //         return i;
    //     })
    //     // ..and only return engagements that have (unanswered) questions left
    //     .filter((i) => i.reports.length !== 0);

    //     console.log(this.List)
    // }
  },
  mounted(){
    this.getDataOnload()
  },
    created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setInitialData") {
        this.getDataOnload();
      }
    });
    // this.autoRefresh();
  },
  beforeDestroy() {
    this.unsubscribe();
    
  },
  
};
</script>
<style lang="scss" scoped>

ul {
//  float: left;
//   width: 12em;
//   margin: 0;
//   padding: 0;
  list-style: initial;

    // color: #535880;
}
// .fundres-list {
//     margin: 0;
//     padding: 0;
//         width: 50%;
//     max-height: 500px;
//     Overflow-y: scroll;
    
 

//     li {
//        float: left;
//   width: 21em;
//   margin: 0;
//   padding: 0;
//         // margin: 0 0 3px 0px;
//         // padding: 3px 5px 5px 5px;
//         // position:relative;
//         // list-style:none;
//         // font-weight: bold;
//         // font-size: 12px;
//         cursor: pointer;
//         -webkit-transition: all 200ms ease-in-out;
//            -moz-transition: all 200ms ease-in-out;
//             -ms-transition: all 200ms ease-in-out;
//              -o-transition: all 200ms ease-in-out;
//                 transition: all 200ms ease-in-out;

//         &:hover a {
//           text-decoration: underline;
//             // border-radius:"255px 15px 225px 15px/15px 225px 15px 255px";
//             // background-color:#0047b2 ;

//             // .nt-arrow-right-fill { 
//             //     color: #fff;
//             //     -webkit-animation: slideRight 350ms ease-in-out;
//             //        -moz-animation: slideRight 350ms ease-in-out;
//             //         -ms-animation: slideRight 350ms ease-in-out;
//             //             animation: slideRight 350ms ease-in-out;
//             // }
            
//             // a { color: #fff }
//         }

//         // .nt-arrow-right-fill {
//         //     margin: 0 0 0 6px;
//         //     padding: 0;
//         //     border: 1px solid transparent;
//         //     color:#0047b2 ; 
//         //     font-size: 18px;
//         //     position: absolute;
//         //     top: 2px;
//         //     left: 5px;
//         // }

//         a { 
//             color: #666; 
//             text-decoration: none;
//         }
//     }
// }

// @-webkit-keyframes slideRight { from { left: -50px } to { left: 6px }}
// @-moz-keyframes    slideRight { from { left: -50px } to { left: 6px }}
// @-ms-keyframes     slideRight { from { left: -50px } to { left: 6px }}
// @keyframes         slideRight { from { left: -50px } to { left: 6px }}
// a{
//   padding: 15px;
// }
// ul.list {
//   list-style-type: none;
//   padding: 0;
//   margin: 0 0 24px 0;
  
//   li > a {
//     cursor: pointer;
    
//     &:hover {
//       text-decoration: underline;
//       // font-size: 0.9rem;
//     }
//   }
// }
</style>